import React, { useEffect } from 'react'
import { Button, DialogActions } from '@material-ui/core'

import ButtonSubmit from '../../common/ButtonSubmit'
import TableActionableMembers from '../common/TableActionableMembers'
import {
  publishClickedExcludeGiftRecipient,
  publishViewed,
} from '../../../util/events/teamsGiftsEventPublishers'
import { VIEWS } from '../../../util/events/teamsEvents'
import DialogContent from './DialogContent'

const StepGiftRecipients = ({ actionableMembers, onBack, onRemove }) => {
  useEffect(() => {
    publishViewed(VIEWS.STEP_GIFT_RECIPIENTS)
  }, [])

  const handleRemove = member => {
    publishClickedExcludeGiftRecipient(member.userId)
    onRemove(member)
  }

  return (
    <>
      <DialogContent>
        <TableActionableMembers
          maxHeight="320px"
          members={actionableMembers}
          onRemove={handleRemove}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onBack}>Back</Button>
        <ButtonSubmit color="primary" variant="contained">
          Next
        </ButtonSubmit>
      </DialogActions>
    </>
  )
}

export default StepGiftRecipients
